var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑品牌" : "新增品牌",
            top: "100px",
            width: "800px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.pram.source == 2
            ? _c("el-tag", { staticStyle: { "margin-left": "50px" } }, [
                _vm._v("福司令"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initLoading,
                  expression: "initLoading",
                },
              ],
              ref: "pram",
              attrs: { "label-width": "130px", model: _vm.pram },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "品牌名称：",
                    prop: "brandName",
                    rules: [
                      {
                        required: true,
                        message: "请填写品牌名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: Boolean(_vm.pram.source == 2),
                      clearable: "",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.brandName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "brandName", $$v)
                      },
                      expression: "pram.brandName",
                    },
                  }),
                  _vm._v(" "),
                  Boolean(_vm.pram.source == 2)
                    ? _c("div", { staticStyle: { color: "#999" } }, [
                        _vm._v("副司令商品不可编辑品牌名称！"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发货时间：",
                    prop: "deliveryTimes",
                    rules: [
                      {
                        required: true,
                        message: "请选择发货时间",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("TimeSelect", {
                    model: {
                      value: _vm.pram.deliveryTimes,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "deliveryTimes", $$v)
                      },
                      expression: "pram.deliveryTimes",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "配送延迟时间：", prop: "deliveryDelay" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, label: "请输入" },
                        model: {
                          value: _vm.pram.deliveryDelay,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "deliveryDelay", $$v)
                          },
                          expression: "pram.deliveryDelay",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [_vm._v("小时")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#999" } }, [
                    _vm._v(
                      "如选择延迟4小时，则用户只能选择下单时间后4小时为配送时间。"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "品牌logo",
                    prop: "brandLogo",
                    rules: _vm.pram.isCombo
                      ? []
                      : [
                          {
                            required: true,
                            message: "请上传",
                            trigger: ["change"],
                          },
                        ],
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: {
                            click: function ($event) {
                              return _vm.modalPicTap("1", "brandLogo")
                            },
                          },
                        },
                        [
                          _vm.pram.brandLogo
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.pram.brandLogo },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.pram.brandLogo
                        ? _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { color: "red", "font-size": "16px" },
                            on: {
                              click: function ($event) {
                                return _vm.removeImg("brandLogo", -1)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "品牌墙：",
                    prop: "brandAlbum",
                    rules: _vm.pram.isCombo
                      ? []
                      : [
                          {
                            required: true,
                            message: "请上传",
                            trigger: ["change"],
                          },
                        ],
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pictrue-imgs" },
                        [
                          _vm.pram.brandAlbum
                            ? _vm._l(_vm.pram.brandAlbum, function (img, i) {
                                return _c(
                                  "div",
                                  { key: i, staticClass: "banner-item" },
                                  [
                                    _c("img", { attrs: { src: img } }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "el-icon-error delete-icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImg("brandAlbum", i)
                                        },
                                      },
                                    }),
                                  ]
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.pram.brandAlbum || _vm.pram.brandAlbum.length < 9
                            ? _c(
                                "div",
                                {
                                  staticClass: "upLoad banner-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalPicTap("2", "brandAlbum")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货方式：", prop: "deliveryType" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.pram.deliveryType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "deliveryType", $$v)
                        },
                        expression: "pram.deliveryType",
                      },
                    },
                    _vm._l(_vm.TRANSPORT_OPTIONS, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "第三方下单须知：", prop: "myRule" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.trule,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "trule", $$v)
                      },
                      expression: "pram.trule",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 9999, label: "排序" },
                    model: {
                      value: _vm.pram.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "sort", $$v)
                      },
                      expression: "pram.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否展示：", prop: "status" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.pram.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "status", $$v)
                      },
                      expression: "pram.status",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "下单须知：", prop: "myRule" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.myRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "myRule", $$v)
                      },
                      expression: "pram.myRule",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }